<template>
  <div class="info-content" v-loading="loading" element-loading-text="页面加载中，请稍等...">
    <div class="tabs">
      <template v-if="!loading">
        <div v-if="!stepInfo.isFollowBatch" class="tab" :class="{'active': tabStep === 1}" @click="tabStep = 1">
          <img v-if="tabStep === 1" src="../../../../../../assets/icons/icon_face1.png" alt="">
          <img v-else src="../../../../../../assets/icons/icon_face.png" alt="">
          <span>人证核验<i v-if="stepInfo.passCardVerify" class="el-icon-check"></i></span>
        </div>
        <div class="tab" :class="{'active': tabStep === 2}" @click="tabStep = 2">
          <img v-if="tabStep === 2" src="../../../../../../assets/icons/icon_review1.png" alt="">
          <img v-else src="../../../../../../assets/icons/icon_review.png" alt="">
          <span>报名表审核<i v-if="+stepInfo.verifyResult" class="el-icon-check"></i></span>
        </div>
        <div v-if="!stepInfo.isFollowBatch" class="tab" :class="{'active': tabStep === 3}" @click="tabStep = 3">
          <img v-if="tabStep === 3" src="../../../../../../assets/icons/icon_Pay1.png" alt="">
          <img v-else src="../../../../../../assets/icons/icon_Pay.png" alt="">
          <span>报名缴费<i v-if="+stepInfo.feeResult" class="el-icon-check"></i></span>
        </div>
        <div v-if="!stepInfo.isFollowBatch && showTestResult" class="tab" :class="{'active': tabStep === 4}" @click="tabStep = 4">
          <img v-if="tabStep === 4" src="../../../../../../assets/icons/icon_exam1.png" alt="">
          <img v-else src="../../../../../../assets/icons/icon_exam.png" alt="">
          <span>考试信息</span>
        </div>
      </template>
    </div>
    <div class="content">
      <viewPortrait v-if="tabStep === 1 && stepInfo.passCardVerify" :student-id="studentId"></viewPortrait>
      <portrait v-else-if="tabStep === 1" :student-id="studentId" :user-data="userData" @verify-pass="verifyPass"></portrait>
      <qualificationReview v-else-if="tabStep === 2" :student-id="studentId" :verifyResult="stepInfo.verifyResult" :passCardVerify="stepInfo.passCardVerify" @qualification-pass="qualificationPass"></qualificationReview>
      <registrationPayment v-else-if="tabStep === 3" :student-id="studentId" :feeResult="+stepInfo.feeResult" @fee-change="feeChange"></registrationPayment>
      <examInfo v-else-if="tabStep === 4 && showTestResult" :student-id="studentId"></examInfo>
      <div v-if="!loading && isError" class="error">
        页面错误，请退出重试
      </div>
    </div>
  </div>
</template>

<script>
import portrait from './portrait.vue'
import viewPortrait from './viewPortrait.vue'
import qualificationReview from './qualificationReview.vue'
import registrationPayment from './registrationPayment.vue'
import examInfo from './examInfo.vue'
export default {
  name: 'portraitCollection',
  data () {
    return {
      isError: false,
      tabStep: 0,
      stepInfo: {},
      loading: false,
      studentId: ''
    }
  },
  methods: {
    getStepInfo () {
      this.loading = true
      let params = {}
      if (this.id) {
        this.studentId = this.id
        params = {
          studentId: this.studentId
        }
      } else {
        params = {
          cardNo: this.userData.cardno,
          studentType: this.studentType
        }
      }
      this.$ajax({
        url: '/workspace/manager/enrolling/student/verifyInfo',
        method: 'post',
        data: this.$qs.stringify(params)
      }).then(response => {
        if (response.data) {
          const data = response.data
          if (data.errorCode === 0) {
            this.stepInfo = data.verifyInfo
            if (this.stepInfo.isFollowBatch) {
              this.tabStep = 2
            } else {
              this.tabStep = 1
            }
            this.studentId = data.studentId
            this.saveIdCard()
          } else {
            this.isError = true
            this.$message.error(data.message || '获取步骤信息失败')
          }
        }
      }, () => {
        this.isError = true
      }).finally(() => {
        this.loading = false
      })
    },
    verifyPass () {
      this.$set(this.stepInfo, 'passCardVerify', true)
    },
    qualificationPass (val) {
      this.$set(this.stepInfo, 'verifyResult', val)
    },
    feeChange (val) {
      this.$set(this.stepInfo, 'feeResult', val)
    },
    saveIdCard () {
      this.$ajax({
        url: '/workspace/manager/enrolling/student/saveCardInfo',
        method: 'post',
        data: this.$qs.stringify({
          cardPhoto: this.userData.photobase64,
          cardBirthday: this.upDateFormat(this.userData.born),
          cardFolk: this.userData.nation + '族',
          cardGender: this.userData.sex,
          cardTrueName: this.userData.name,
          cardNo: this.userData.cardno,
          studentId: this.studentId
        })
      })
    },
    upDateFormat (time) {
      if (time) {
        return time.substring(0, 4) + '-' + time.substring(4, 6) + '-' + time.substring(6, 8)
      } else {
        return ''
      }
    }
  },
  created () {
    this.getStepInfo()
  },
  components: {
    qualificationReview,
    registrationPayment,
    examInfo,
    portrait,
    viewPortrait
  },
  props: {
    showTestResult: {
      default: true
    },
    userData: {
      type: Object,
      default: () => {}
    },
    studentType: String,
    id: {
      type: String,
      default: ''
    }
  }
  // watch: {
  //   'studentId': {
  //     handler (val) {
  //       if (val) {
  //         this.getStepInfo()
  //       }
  //     },
  //     immediate: true
  //   }
  // }
}
</script>

<style scoped lang="scss">
.info-content {
  width: 100%;
  height: 100%;
  background-color: #0D59A7;
  background-image: url("../../../../../../assets/icons/background.png");
  background-repeat: no-repeat;
  background-size: 130px;
  background-position: 94% top;
  .blue-title {
    color: #0D59A7;
    position: relative;
    font-weight: 550;
    padding-left: 10px;
    font-size: 13px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background-color: #02A7F0;
      margin-right: 10px;
      position: absolute;
      left: 2px;
    }
  }
  & > .tabs {
    display: flex;
    justify-content: center;
    height: 84px;
    align-items: center;
    & > .tab {
      width: 150px;
      height: 100%;
      color: #9EBDDC;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      & > img {
        width: 28px;
        height: 28px;
        margin-bottom: 5px;
      }
      span {
        margin-right: 5px;
        i {
          color: #70B603;
          margin-left: 3px;
        }
      }
    }
    & > .active {
      color: #fff;
    }
  }
  & > .content {
    width: 100%;
    height: 482px;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    background-color: #fff;
    margin: 0 auto;
    overflow: hidden;
  }
}
.error {
  font-size: 26px;
  text-align: center;
  height: 100px;
  width: 100%;
  line-height: 100px;
}
</style>
